import React, { useState, useEffect } from "react";
import { Link } from 'gatsby';
import styled from "styled-components";
import { createClient } from "@supabase/supabase-js";
import ButtonWhite from "../button_white";
import White from "../white";
import Container from "../container";
import Label from "../label";

import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

const supabase_options = {
  db: {
    schema: "public",
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: {
    // headers: { 'x-my-custom-header': 'my-app-name' },
  },
};

const supabase = createClient(
  "https://hdrrfppxfnaxzdmcgjhc.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhkcnJmcHB4Zm5heHpkbWNnamhjIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODY2NjI1NjIsImV4cCI6MjAwMjIzODU2Mn0.1CSYCMlEd8qIRc0kKhPZ4c5rnQxvaCkIJ_4NSvvqYZs",
  supabase_options,
);

const Form = styled.form`
  text-align: left;
  width: 100%;
  h3 {
    margin-left: 0;
    margin-bottom: 64px;
    margin-top: 98px;
    &:first-of-type {
      margin-top: 0;
    }
  }
`;

const TermsConditions = styled.p`
  display: block;
`

const Row = styled.div`
  display: flex;
  column-gap: 30px;
  margin-bottom: ${(props) => (props.mb0 ? "20px" : "80px")};
  justify-content: space-between;
  .buttons {
    align-items: center;
    p {
      min-width: 545px;
      @media (max-width: 768px) {
        min-width: 1px;
        font-size: 18px;
      }
    }
  }
  &.grouped {
    margin-bottom: 0;
    @media(max-width: 768px) {
    }
  }
  &.grouped-col {
    margin-bottom: 1rem;
    @media(max-width: 768px) {
      margin-bottom: 0;
    }
  }
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 0;
  }
`;

const Col = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {

  }
  &.buttons {
    margin-top: 50px;
    align-items: center;
    input {
      margin-right: 10px;
      height: 20px;
      width: 20px;
    }
  }
  &.buttons-end {
    margin-top: 50px;
    align-items: center;
    justify-content: flex-end;
    @media(max-width: 768px) {
      justify-content: center;
      .center {
        width: 100%;
        button {
          width: 100%;
        }
      }
    }
  }
`;

const PayUp = styled.div`
  text-align: center;
  margin-top: 46px;
  padding-top: 2rem;
  padding-bottom: 2rem;
  h3 {
    margin-top: 2rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Closed = styled.div`
  text-align: center;
  form {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
  button {
    margin-top: 1rem;
  }
`

const Field = styled.div`
  display: flex;
  flex-direction: column;
  border: none;
  width: 100%;
  color: #000;
  @media(max-width: 768px) {
    margin-top: 0rem;
    margin-bottom: 1rem;
    .mobile-bottom-margin {
      margin-bottom: 0rem !important;
      margin-top: 1rem !important;
    }
  }
  ::placeholder {
    color: #a1a1a1;
    opacity: 1;
  }
  ::-ms-input-placeholder {
    color: #a1a1a1;
  }
  span {
    font-size: 18px;
    color: #888;
    margin-top: 8px;
  }
  select {
    width: 100%;
    max-width: 100%;
    &:disabled {
      color: #aeaeae;
    }
    margin-top: 14px;
    @media(max-width: 768px) {
      margin-top: 0;
    }
    &:focus {
      outline: 0;
    }
    color: #000;
    padding: 16px;
    border: 2px solid #a1a1a1;
    border-radius: 10px;
    appearance: none;
    background-color: #fff;
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 28 29' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 9L14 20L24 9' stroke='%23434343' stroke-width='2' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  }
  input[type="text"],
  input[type="tel"],
  input[type="email"],
  input[type="date"] {
    margin-top: 14px;
    padding: 16px;
    border: 2px solid #a1a1a1;
    border-radius: 10px;
    width: 100%;
    color: #000;
    background-color: #fff;
    appearance: none;
    -webkit-appearance: none;
    @media(max-width: 768px) {
      margin-top: 0;
    }
    &:focus {
      outline: 0;
    }
  }
  input[type="date"] {
    @media (max-width: 768px) {
      min-height: 46px;
    }
  }
`;

const Error = styled.span`
  color: red;
  margin-top: 0.5rem;
  display: inline-block;
  font-size: 12px;
  width: 100%;
  text-align: center;
`;

const PhoneContainer = styled.div`
  max-width: 100%;
  margin-top: 18px;
  .react-international-phone-input {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
    min-height: 54px !important;
    margin-top: 0 !important;
    margin-left: 16px !important;
    font-size: 16px !important;
  }
  .react-international-phone-country-selector-button {
    border: none;
    margin-left: 4px;
  }
  .react-international-phone-country-selector {
    display: flex;
    align-items: center;
  }
  input {
    padding-top: 16px;
    padding-bottom: 16px;
  }
`

const SignupUltra = ({module}) => {

  const { allow_magnum, allow_solo_pair } = module;

  const isBrowser = typeof window !== "undefined"

  const [waitingData, setWaitingData] = useState({
    name: "",
    email: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    surname: "",
    email: "",
    mobile: "",
    dob: "",
    address_1: "",
    address_2: "",
    city: "",
    postcode: "",
    region: "",
    country: "",
    partner_name: "",
    partner_surname: "",
    partner_email: "",
    partner_mobile: "",
    partner_address_1: "",
    partner_address_2: "",
    partner_city: "",
    partner_postcode: "",
    partner_region: "",
    partner_country: "",
    route: "",
  });


  const prices = [
    { route: "ultra-2024-full-pair", price: "930.00" },
    { route: "ultra-2024-full-solo", price: "465.00" },
    { route: "ultra-2024-short-pair", price: "930.00" },
    { route: "ultra-2024-short-solo", price: "465.00" },
    { route: "ultra-2024-magnum-opus", price: "100.00" }
  ]


  const capitalizeFirstLetter = (str) => {
    // Check if the input is a valid string
    if (typeof str !== "string" || str.length === 0) {
      return str;
    }

    // Capitalize the first letter and concatenate with the rest of the string
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const [riderCount, setRiderCount] = useState(0);
  const [magnumCount, setMagnumCount] = useState(0);

  const [price, setPrice] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [registerDisabled, setRegisterDisabled] = useState(true);
  const [phone, setPhone] = useState('');
  const [partner_phone, setPartnerPhone] = useState('');
  const [registerLabel, setRegisterLabel] = useState("Register");

  const [waitingDisabled, setWaitingDisabled] = useState(true);
  const [waitingLabel, setWaitingLabel] = useState("SUBMIT");
  const [productUrl, setProductUrl] = useState(false);

  let required_fields;

  function formatTitle(inputString) {
    const words = inputString.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1));
    const result = words.join(' ');
    return result;
  }

  const loadRiders = async () => {
		// let { data, count } = await supabase
		// 	.from('ultra_2024')
		// 	.select('*', { count: 'exact', head: true })

      let { data, error } = await supabase
			.from('totals')
			.select('*')

      let totalRiders = 0;
      let totalMagnum = 0;

      data.forEach(item => {
        // Check if the route contains the word "pair"
        if (item.route.includes("pair")) {
          // If it does, add 2 times the total to the overall total
          totalRiders += 2 * item.total;
        } else {
          // If not, add the total to the overall total
          if(!item.route.toLowerCase().includes('magnum')) {
            totalRiders += item.total;
          } else {
            totalMagnum += item.total;
          }
        }
      });

      setRiderCount(totalRiders || 0);
      setMagnumCount(totalMagnum || 0);

	};

  useEffect(() => {
    loadRiders();
  }, []);

  useEffect(() => {
    if(waitingData.name !== '' && waitingData.email !== '') {
      setWaitingDisabled(false);
    } else {
      setWaitingDisabled(true);
    }
  }, [waitingData]);

  useEffect(() => {

    if(formData.route === 'ultra-2024-full-solo') {
      setProductUrl('https://pancelticrace.com/shop/ultra-2024-full-solo-K1aviM42mU');
    } else if(formData.route === 'ultra-2024-full-pair') {
      setProductUrl('https://pancelticrace.com/shop/ultra-2024-full-pair-fBUs6HGsC0');
    } else if(formData.route === 'ultra-2024-short-solo') {
      setProductUrl('https://pancelticrace.com/shop/ultra-2024-short-solo-es1NUCqw6P');
    } else if(formData.route === 'ultra-2024-short-pair') {
      setProductUrl('https://pancelticrace.com/shop/ultra-2024-short-pair-sroMCTe0N9');
    } else if(formData.route === 'ultra-2024-magnum-opus') {
      setProductUrl('https://pancelticrace.com/shop/ultra-2024-magnum-opus-byN7Dj3ZXG');
    }

    if(phone !== '') {
      formData.mobile = phone;
    }

    if(partner_phone !== '') {
      formData.partner_mobile = partner_phone;
    }

    if (formData.route !== '') {
      const filtered_price = prices.filter(p => p.route === formData.route)[0].price;
      setPrice(filtered_price)
    }

    if (formData.route.includes('PAIR')) {

      required_fields = [
        "route",
        "name",
        "surname",
        "email",
        "mobile",
        "dob",
        "address_1",
        "partner_name",
        "partner_surname",
        "partner_email",
        "partner_mobile",
        "partner_address_1",
        "partner_dob",
        "partner_gender"
      ];

    } else { // SOLO

      required_fields = [
        "route",
        "name",
        "surname",
        "email",
        "mobile",
        "dob",
        "address_1",
      ];

    }

    if (required_fields.every((field) => formData[field] !== "") && acceptTerms === true) { // ready to submit
      setRegisterDisabled(false);
    } else {
      setRegisterDisabled(true);
    }

  }, [formData, acceptTerms, phone, partner_phone]);

  const handleWaiting = async (e) => {
    e.preventDefault();
    setWaitingLabel("SENT");

    let { data, error } = await supabase
      .from("waiting_list")
      .insert([{ ...waitingData }])
      .select();
  }

  const handleRegister = async (e) => {
    e.preventDefault();
    setRegisterLabel("Registering...");

    let { data, error } = await supabase
      .from("ultra_2024")
      .insert([{ ...formData }])
      .select();
    setRegistered(true);
    setRegisterLabel("Next");
  };


  const handleCheckboxChange = () => {
    setAcceptTerms(!acceptTerms);
  }


  return (
    <White>
      <Container>

        { (allow_magnum === false && allow_solo_pair === false) &&
          <Closed>
            <h3>Entries are now closed for the Pan Celtic Race 2024.</h3>
            <p>To join the waiting list, please enter your details below</p>

            <Form>
              <Row mb0>
              <Col>
                <Field>
                  <Label>
                    Name <sup>*</sup>
                  </Label>
                  <input
                    required
                    onChange={(e) =>
                      setWaitingData({ ...waitingData, name: e.target.value })
                    }
                    value={waitingData.name}
                    type="text"
                    name="name"
                    id="name"
                    placeholder=""
                  />
                </Field>
              </Col>
            </Row>
            <Row mb0>
            <Col>
              <Field>
                <Label>Email <sup>*</sup></Label>
                <input
                  required
                  onChange={(e) =>
                    setWaitingData({ ...waitingData, email: e.target.value })
                  }
                  value={waitingData.email}
                  type="text"
                  name="email"
                  id="email"
                  placeholder=""
                />
              </Field>
            </Col>
          </Row>
            <ButtonWhite disabled={waitingDisabled} onClick={(e) => handleWaiting(e)}>
              {waitingLabel}
            </ButtonWhite>
            </Form>
          </Closed>
        }

        { (allow_magnum === true || allow_solo_pair === true) &&
          <Form>
            {!registered && (
              <>
                <h3>Your details</h3>

                <Row mb0>
                  <Col>
                    <Field>
                      <Label>
                        Rider Name <sup>*</sup>
                      </Label>
                      <input
                        required
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                        value={formData.name}
                        type="text"
                        name="name"
                        id="name"
                        placeholder="First Name *"
                      />
                      <span>As it appears in your passport</span>
                    </Field>
                  </Col>
                  <Col>
                    <Field>
                      <Label></Label>
                      <input
                        required
                        onChange={(e) =>
                          setFormData({ ...formData, surname: e.target.value })
                        }
                        value={formData.surname}
                        type="text"
                        name="surname"
                        id="surname"
                        placeholder="Last Name *"
                      />
                      <span>As it appears in your passport</span>
                    </Field>
                  </Col>
                </Row>

                <Row className="grouped-col">
                  <Col>
                    <Field>
                      <Label>
                        Email address <sup>*</sup>
                      </Label>
                      <input
                        required
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        value={formData.email}
                        type="email"
                        name="email"
                        id="email"
                        placeholder="name@email.com *"
                      />
                    </Field>
                  </Col>
                  <Col>
                    <Field>
                    <Label>Mobile number <sup>*</sup></Label>
                      <PhoneContainer>
                        <PhoneInput
                        reuired
                        name="mobile"
                        id="mobile"
                        placeholder="+00 00000000000"
                        defaultCountry="gb"
                        value={phone}
                        onChange={(phone) => setPhone(phone)}
                        />
                      </PhoneContainer>
                    </Field>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Field>
                      <Label>
                        Date of birth <sup>*</sup>
                      </Label>
                      <input
                        required
                        onChange={(e) =>
                          setFormData({ ...formData, dob: e.target.value })
                        }
                        value={formData.dob}
                        type="text"
                        placeholder="DD/MM/YYYY *"
                        name="dob"
                        id="dob"
                      />
                      <span>Needed only for ferry bookings</span>
                    </Field>
                  </Col>
                  <Col>
                    <Field>
                      <Label>Gender *</Label>
                      <select
                        onChange={(e) =>
                          setFormData({ ...formData, gender: e.target.value })
                        }
                        name="gender"
                        id="gender"
                      >
                        <option disabled selected>
                          Please select
                        </option>
                        <option
                          selected={formData.gender === "female" ? true : false}
                          value="female"
                        >
                          Female
                        </option>
                        <option
                          selected={formData.gender === "male" ? true : false}
                          value="male"
                        >
                          Male
                        </option>
                      </select>
                      <span>Needed only for ferry bookings</span>
                    </Field>

                  </Col>
                </Row>

                <Row className="grouped">
                  <Field>
                    <Label>Address *</Label>
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, address_1: e.target.value })
                      }
                      value={formData.address1}
                      type="text"
                      name="address_1"
                      id="address_1"
                      placeholder="Address Line 1 *"
                    />
                    <input
                      onChange={(e) =>
                        setFormData({ ...formData, address_2: e.target.value })
                      }
                      value={formData.address2}
                      className="mobile-bottom-margin"
                      type="text"
                      name="address_2"
                      id="address_2"
                      placeholder="Address Line 2"
                    />
                  </Field>
                </Row>

                <Row className="grouped">
                  <Col>
                    <Field>
                      <input
                        onChange={(e) =>
                          setFormData({ ...formData, city: e.target.value })
                        }
                        value={formData.city}
                        type="text"
                        name="city"
                        id="city"
                        placeholder="City *"
                      />
                    </Field>
                  </Col>
                  <Col>
                    <Field>
                      <input
                        onChange={(e) =>
                          setFormData({ ...formData, region: e.target.value })
                        }
                        value={formData.region}
                        type="text"
                        name="region"
                        id="region"
                        placeholder="State/Province/Region"
                      />
                    </Field>
                  </Col>
                </Row>

                <Row mb0>
                  <Col>
                    <Field>
                      <input
                        onChange={(e) =>
                          setFormData({ ...formData, postcode: e.target.value })
                        }
                        value={formData.postcode}
                        type="text"
                        name="postcode"
                        id="postcode"
                        placeholder="Postal Code *"
                      />
                    </Field>
                  </Col>
                  <Col>
                    <Field>
                      <input
                        onChange={(e) =>
                          setFormData({ ...formData, country: e.target.value })
                        }
                        value={formData.country}
                      sz type="text"
                        name="country"
                        id="country"
                        placeholder="Country *"
                      />
                    </Field>
                  </Col>
                </Row>

                <h3>Route</h3>

                <Row mb0>
                  <Col>
                    <Field>
                      <Label>Route Choice *</Label>
                      <select
                        onChange={(e) => setFormData({ ...formData, route: e.target.value })} name="route" id="route">
                        <option disabled selected>Please select</option>
                        { allow_solo_pair &&
                          <>
                          <option selected={formData.route === "ultra-2024-full-pair" ? true : false} value="ultra-2024-full-pair">FULL PAIR (£930.00)</option>
                          <option selected={formData.route === "ultra-2024-full-solo" ? true : false} value="ultra-2024-full-solo">FULL SOLO (£465.00)</option>
                          <option selected={formData.route === "ultra-2024-short-pair" ? true : false} value="ultra-2024-short-pair">SHORT PAIR (£930.00)</option>
                          <option selected={formData.route === "ultra-2024-short-solo" ? true : false} value="ultra-2024-short-solo">SHORT SOLO (£465.00)</option>
                          </>
                        }
                        { allow_magnum &&
                          <option selected={formData.route === "ultra-2024-magnum-opus" ? true : false} value="ultra-2024-magnum-opus">MAGNUM OPUS (£100.00 Deposit)</option>
                        }
                      </select>
                    </Field>
                  </Col>
                  <Col>&nbsp;</Col>
                </Row>

                {(formData.route === 'ultra-2024-full-pair' || formData.route === 'ultra-2024-short-pair') &&
                  <>
                    <h3>Partner Details</h3>

                    <Row mb0>
                      <Col>
                        <Field>
                          <Label>
                            Their Name <sup>*</sup>
                          </Label>
                          <input
                            onChange={(e) =>
                              setFormData({ ...formData, partner_name: e.target.value })
                            }
                            value={formData.partner_name}
                            type="text"
                            name="partner_name"
                            id="partner_name"
                            placeholder="First Name *"
                          />
                          <span>As it appears in their passport</span>
                        </Field>
                      </Col>
                      <Col>
                        <Field>
                          <Label></Label>
                          <input
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                partner_surname: e.target.value,
                              })
                            }
                            value={formData.partner_surname}
                            type="text"
                            name="partner_surname"
                            id="partner_surname"
                            placeholder="Last Name *"
                          />
                          <span>As it appears in their passport</span>
                        </Field>
                      </Col>
                    </Row>



                    <Row mb0>
                      <Col>
                        <Field>
                          <Label>
                            Their Email address <sup>*</sup>
                          </Label>
                          <input
                            onChange={(e) =>
                              setFormData({ ...formData, partner_email: e.target.value })
                            }
                            value={formData.partner_email}
                            type="email"
                            name="partner_email"
                            id="partner_email"
                            placeholder="name@email.com *"
                          />
                        </Field>
                      </Col>
                      <Col>
                        <Field>
                          <Label>
                            Their Mobile number <sup>*</sup>
                          </Label>
                          <PhoneContainer>
                          <PhoneInput
                          reuired
                          name="mobile"
                          id="mobile"
                          placeholder="+00 00000000000"
                          defaultCountry="gb"
                          value={partner_phone}
                          onChange={(partner_phone) => setPartnerPhone(partner_phone)}
                          />
                        </PhoneContainer>
                        </Field>
                      </Col>
                    </Row>

                    <Row>
                    <Col>
                      <Field>
                        <Label>
                          Their Date of birth <sup>*</sup>
                        </Label>
                        <input
                          required
                          onChange={(e) =>
                            setFormData({ ...formData, partner_dob: e.target.value })
                          }
                          value={formData.partner_dob}
                          type="text"
                          placeholder="DD/MM/YYYY *"
                          name="partner_dob"
                          id="partner_dob"
                        />
                        <span>Needed only for ferry bookings</span>
                      </Field>
                    </Col>
                    <Col>
                      <Field>
                        <Label>Their Gender *</Label>
                        <select
                          onChange={(e) =>
                            setFormData({ ...formData, partner_gender: e.target.value })
                          }
                          name="partner_gender"
                          id="partner_gender"
                        >
                          <option disabled selected>
                            Please select
                          </option>
                          <option
                            selected={formData.partner_gender === "female" ? true : false}
                            value="female"
                          >
                            Female
                          </option>
                          <option
                            selected={formData.partner_gender === "male" ? true : false}
                            value="male"
                          >
                            Male
                          </option>
                        </select>
                        <span>Needed only for ferry bookings</span>
                      </Field>

                    </Col>
                    </Row>

                    <Row className="grouped">
                      <Field>
                        <Label>
                          Their Address <sup>*</sup>
                        </Label>
                        <input
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              partner_address_1: e.target.value,
                            })
                          }
                          value={formData.partner_address_1}
                          type="text"
                          name="partner_address_1"
                          id="partner_address_1"
                          placeholder="Address Line 1 *"
                          className="mobile-bottom-margin"
                        />
                        <input
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              partner_address_2: e.target.value,
                            })
                          }
                          value={formData.partner_address_2}
                          type="text"
                          name="partner_address_2"
                          id="partner_address_2"
                          placeholder="Address Line 2"
                        />
                      </Field>
                    </Row>

                    <Row className="grouped">
                      <Col>
                        <Field>
                          <input
                            onChange={(e) =>
                              setFormData({ ...formData, partner_city: e.target.value })
                            }
                            value={formData.partner_city}
                            type="text"
                            name="partner_city"
                            id="partner_city"
                            placeholder="City"
                          />
                        </Field>
                      </Col>
                      <Col>
                        <Field>
                          <input
                            onChange={(e) =>
                              setFormData({ ...formData, partner_region: e.target.value })
                            }
                            value={formData.partner_region}
                            type="text"
                            name="partner_region"
                            id="partner_region"
                            placeholder="State/Province/Region"
                          />
                        </Field>
                      </Col>
                    </Row>

                    <Row mb0>
                      <Col>
                        <Field>
                          <input
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                partner_postcode: e.target.value,
                              })
                            }
                            value={formData.partner_postcode}
                            type="text"
                            name="partner_postcode"
                            id="partner_postcode"
                            placeholder="Postal Code"
                          />
                        </Field>
                      </Col>
                      <Col>
                        <Field>
                          <input
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                partner_country: e.target.value,
                              })
                            }
                            value={formData.partner_country}
                            type="text"
                            name="partner_country"
                            id="partner_country"
                            placeholder="Country"
                          />
                        </Field>
                      </Col>
                    </Row>

                  </>
                }

                <Row className="buttons">
                  <Col className="buttons">
                    <input type="checkbox" checked={acceptTerms} onChange={() => handleCheckboxChange()} />
                    <TermsConditions>I have read and accept the <Link href="/ultra/terms-conditions">terms and conditions</Link></TermsConditions>
                  </Col>
                  <Col className="buttons-end">
                    <div className="center">
                      <ButtonWhite
                        disabled={formData.route !== "" ? false : true}
                        className="hidden snipcart-add-item"
                        data-item-id={formData.route}
                        data-item-name={`The ${formatTitle(formData.route)}`}
                        data-item-price={price}
                        data-item-quantity="1"
                        data-item-url={productUrl}
                        data-item-description={
                          formData.name +
                          " " +
                          formData.surname +
                          " - " +
                          formData.email
                        }
                      >
                        Go to payment
                      </ButtonWhite>

                      <ButtonWhite disabled={registerDisabled} onClick={(e) => handleRegister(e)}>
                        {registerLabel}
                      </ButtonWhite>

                      {registerDisabled === true && (
                        <>
                          <br />
                          <Error>Please complete required fields</Error>
                        </>
                      )}

                    </div>
                  </Col>
                </Row>
              </>
            )}

            {registered && (
              <>
                <PayUp>
                  <h3>
                    {formData.name}, you've been registered for the Ultra 2024! Your place will only be confirmed once payment has been made.
                  </h3>

                  <ButtonWhite
                    disabled={formData.route !== "" ? false : true}
                    className="snipcart-add-item"
                    data-item-id={formData.route}
                    data-item-name={`The ${formatTitle(formData.route)}`}
                    data-item-price={price}
                    data-item-quantity="1"
                    data-item-url={productUrl}
                    data-item-description={
                      formData.name +
                      " " +
                      formData.surname +
                      " - " +
                      formData.email
                    }
                  >
                    Go to payment
                  </ButtonWhite>
                </PayUp>
              </>
            )}
          </Form>
        }

      </Container>
    </White>
  );
};
export default SignupUltra;
